<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'deviceModelCrud'"
            :crudName="$t('Devices Model')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "deviceModelTable",
      showMessageImport: false,
      deviceModelCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "device_type",
        "supplier_id",
        "actions",
      ],
      tableData: ["id", "name", "device_type", "supplier_id"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "device_type", "supplier_id"],
        sortable: ["id", "name", "device_type", "supplier_id"],
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down"
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('Id'),
          name: this.$t('name'),
          device_type: this.$t('Device Type'),
          supplier_id: this.$t('Supplier'),
          actions: this.$t('action'),
        },
        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {
          supplier_id: [],
        },
        templates: {
          supplier_id: (h, row) => row.supplier?.name ?? '',
          device_type: (h, row) => {
            const types = {
              mobile: this.$t('Celular'),
              fixed_tracker: this.$t('Rastreador Fixo')
            };
            return h('span', types[row.device_type] ?? row.device_type);
          }
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["supplier"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "deviceModels",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('Id'),
        device_type: this.$t('Device Type'),
        name: this.$t('name'),
        supplier_id: this.$t('Supplier'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }

    }

  },
  methods: {
    query(query) {
      let columns = {
        id: "id",
        name: "name",
        device_type: "device_type",
        supplier_id: "supplier_id"
      };
      let filters = "";
      $.each(query, function (index, value) {
        if (value) {
          filters += columns[index] + "=" + value + "&";
        }
      });
      return filters;
    }
  },
  mounted() {
    let api = this.$store.state.api + 'suppliers';
    axios.get(api).then(res => {
      const suppliers = res.data.data || res.data;
      this.optionsOrigin.listColumns.supplier_id = suppliers.map(f => ({
        id: f.id,
        text: f.name
      }));
    }).catch(err => {
      console.error("Error loading suppliers:", err);
    });
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
